import PageSeo from 'src/components/Seo'

interface SeoProps {
  title?: string
  description?: string
  keywords?: string
  canonical?: string  // Optional: canonical URL
  noindex?: boolean
}

const Seo: React.FC<SeoProps> = ({ title, description, keywords, canonical, noindex }) =>
  <PageSeo title={title || 'Suche'} description={description} keywords={keywords}
    canonical={canonical || '/suche'} robots={noindex ? 'noindex,follow' : undefined} />

export default Seo;
